<!--Top Section-->
<div class="pt-2"></div>
<div class="d-flex justify-content-between flex-wrap flex-md-nowrap align-items-center pt-3 pb-2 mb-3 border-bottom">
  <h1 class="h2">Revenue Calculator</h1>
  <!--buttons-->
  <div class="btn-toolbar d-flex justify-content-between  pt-3 pb-2 mb-3">
    <div class="col pb-3">
      <div class="btn-group pr-3">
        <!-- goBack() methos to back to previous component -->
        <a class="btn btn-sm btn-outline-secondary" href="https://forms.gle/n915nuAA4hYVYcGe6" value="feedback"
          target="_blank">Results Feedback</a>
      </div>
      <div class="btn-group pr-3">
        <!--button class="btn btn-sm btn-outline-secondary" (click)="toggle()">Download</button-->
        <button mat-raised-button color="primary" id="printbtn" (click)="exportOnClick()">Download PDF</button>
      </div>
      <div class="btn-group pr-3">
        <!-- goBack() methos to back to previous component -->
        <button class="btn btn-sm btn-outline-secondary" (click)="goBack()">Go Back</button>
      </div>
    </div>
  </div>
</div>
<mat-tab-group [selectedIndex]="tabNum">
  <mat-tab label="Revenue">
    <div>

      <h2>Revenue:</h2>
      <div id="viewChart">
        <div>
          <h3><b>Sustainible Revenue Calculator</b></h3>
        </div>

        <canvas baseChart [chartType]="chartType" [datasets]="chartData" [options]="chartOptions"
          [labels]="chartLabels" [colors]="chartColors" [legend]="chartLegend" [plugins]="lineChartPlugins">
        </canvas>

        <!---
        <section>
          <mat-checkbox class="chart-checkbox" (change)="showIRevenue()">{{ iName }} Standard Revenue</mat-checkbox>
          <mat-checkbox (change)="showIProfit()">{{ iName }} Standard Profit</mat-checkbox>
        </section>
      -->

        <div>
          <h3><b>Recommendations:</b></h3>
          <p>{{retrieveRecommandationText('capitalSeeking')}}</p>
          <p class="recommendations-text">Month you will break even: <span *ngFor="let month of monthsEven">{{
              month }} </span></p>
          <ng-container *ngIf="profitableAfter24M == true; else notProfitable">
            <p class="recommendations-text">This model may withstand long enough to become profitable.</p>
          </ng-container>
          <ng-template #notProfitable>
            <p class="recommendations-text">This may not withstand long enough to be profitable with this amount of
              customers unless you receive financing.</p>
          </ng-template>
          <!----
          <ng-container *ngIf="revStartingCosts < irevStartingCosts; else sCostsGreater">
            <p class="recommendations-text">Your starting costs are less than your industry's standard</p>
          </ng-container>
          <ng-template #sCostsGreater>
            <p class="recommendations-text">Your starting costs are greater than your industry's standard</p>
          </ng-template>
          <ng-container *ngIf="revFixedCostPerMonth < irevFixedCosts; else fCostsGreater">
            <p class="recommendations-text">Your fixed costs per month are less than your industry's standard</p>
          </ng-container>
          <ng-template #fCostsGreater>
            <p class="recommendations-text">Your fixed costs per month are greater than your industry's standard</p>
          </ng-template>
          -->
        </div>
<form *ngIf="calcRevenueFormGroup" [formGroup]="calcRevenueFormGroup"  novalidate (ngSubmit)="onSubmit()">
        <div class="float-slider">
          <div>
           <!-- <mat-slider color="primary" type="range" id="revInitialCapitalSlider" min="0" max="100000" step="1"
              [(ngModel)]="revInitialCapital" (change)="chartUpdate()" thumbLabel [displayWith]="formatLabelMoney">
            </mat-slider>-->
            <span>Initial capital: $</span>
            <mat-form-field>
            <input class="mat-input" matInput #idkWhatThisDoes type="number" min="0" max="100000"
              formControlName="revInitialCapital" (change)="chartUpdate()">
            <mat-icon matSuffix matTooltip="Your estimated initial capital.">
              info
            </mat-icon>  
          </mat-form-field>
          </div>
          <div>
           <!--<mat-slider color="primary" type="range" id="revStartingCostsSlider" min="0" max="100000" step="1"
              [(ngModel)]="revStartingCosts" (change)="chartUpdate()" thumbLabel [displayWith]="formatLabelMoney">
            </mat-slider>--> 
            <span>Starting Costs: $</span>
            <mat-form-field>
            <input class="mat-input" matInput #idkWhatThisDoes type="number" id="revStartingCostsInput" min="0"
              max="100000" formControlName="revStartingCosts" (change)="chartUpdate()">
            <mat-icon matSuffix matTooltip="Your estimated starting costs.">
              info
            </mat-icon>
          </mat-form-field>
          </div>

          <div>
            <!--
            <mat-slider color="primary" type="range" id="revPerUserSlider" min="0" max="1000" step="1"
              [(ngModel)]="revPerUser" (change)="chartUpdate()" thumbLabel [displayWith]="formatLabelMoney">
            </mat-slider>-->
            <span>Average Revenue per Transaction: $</span>
            <mat-form-field>
            <input class="mat-input" matInput #idkWhatThisDoes type="number" id="revPerUserInput" min="0"
              max="1000" formControlName="revPerUser" (change)="chartUpdate()">
            <mat-icon matSuffix matTooltip="How much do you charge for your product per customer?">
              info
            </mat-icon>
          </mat-form-field>
          </div>

          <div>
        <!--    <mat-slider color="primary" type="range" id="revCOGSSlider" min="0" max="1000" step="1" [(ngModel)]="revCOGS"
              (change)="chartUpdate()" thumbLabel [displayWith]="formatLabelMoney"></mat-slider>-->
            <span>Cost of Goods Sold:</span>
            <mat-form-field>
            <input class="mat-input" matInput #idkWhatThisDoes type="number" id="revCOGSInput" min="0" max="1000"
            formControlName="revCOGS" (change)="chartUpdate()">
            <mat-icon matSuffix matTooltip="How much did it cost to create your product per customer?">
              info
            </mat-icon>
          </mat-form-field>
          </div>

          <div>
          <!-- <mat-slider color="primary" type="range" id="revFixedCostPerMonthSlider" min="0" max="10000" step="100"
              [(ngModel)]="revFixedCostPerMonth" (change)="chartUpdate()" thumbLabel [displayWith]="formatLabelMoney">
            </mat-slider>--> 
            <span>Fixed Costs per Month: $</span>
            <mat-form-field>
            <input class="mat-input" matInput #idkWhatThisDoes type="number" id="revFixedCostPerMonthInput" min="0"
              max="10000" formControlName="revFixedCostPerMonth" (change)="chartUpdate()">
            <mat-icon matSuffix matTooltip="How much money are you spending per month to run your business?">
              info
            </mat-icon>
          </mat-form-field>
          </div>
        </div>

        <div class="float-slider">
          <div>
           <!-- <mat-slider color="primary" type="range" id="revInitUsersSlider" min="0" max="10000" step="1"
              [(ngModel)]="revInitUsers" (change)="chartUpdate()" thumbLabel></mat-slider>-->
            <span>Starting Monthly Customers:</span>
            <mat-form-field>
            <input class="mat-input" matInput #idkWhatThisDoes type="number" min="0" max="10000"
            formControlName="revInitUsers" (change)="chartUpdate()">
            <mat-icon matSuffix matTooltip="How many customers do you estimate to start with? Or have now?">
              info
            </mat-icon>
          </mat-form-field>
          </div>

          <!----
          <div>
            <mat-slider type="range" id="monthlyUsersSlider" min="0" max="10000" step="1" [(ngModel)]="monthlyUsers"
              (change)="chartUpdate()" thumbLabel></mat-slider>
            <label>Monthly Users:</label>
            <input matInput #idkWhatThisDoes type="number" id="monthlyUsersInput" min="0" max="10000"
              [(ngModel)]="monthlyUsers" (change)="chartUpdate()">
          </div>
        -->

          <div>
           <!-- <mat-slider color="primary" type="range" id="revMonthlyUserGrowthSlider" min="0" max="100" step="1"
              [(ngModel)]="revMonthlyUserGrowth" (change)="chartUpdate()" thumbLabel
              [displayWith]="formatLabelPercent"></mat-slider>-->
            <span>Monthly Customer Growth:</span>
            <mat-form-field>
            <input class="mat-input" matInput #idkWhatThisDoes type="number" id="revMonthlyUserGrowthInput" min="0"
              max="20" formControlName="revMonthlyUserGrowth" (change)="chartUpdate()">
            <span>%</span>
            <mat-icon matSuffix
              matTooltip="In percentage, how much do you estimate your customer base to grow each month?">
              info
            </mat-icon>
          </mat-form-field>
          </div>

          <div>
            <!--<mat-slider color="primary" type="range" id="revMonthlyUserLossSlider" min="0" max="100" step="1"
              [(ngModel)]="revMonthlyUserLoss" (change)="chartUpdate()" thumbLabel [displayWith]="formatLabelPercent">
            </mat-slider>-->
            <span>Monthly Customer Loss:</span>
            <mat-form-field>
            <input class="mat-input" matInput #idkWhatThisDoes type="number" id="revMonthlyUserLossInput" min="0"
              max="20" formControlName="revMonthlyUserLoss" (change)="chartUpdate()">
            <span>%</span>
            <mat-icon matSuffix
              matTooltip="In percentage, how much do you estimate your customer base to decrease each month?">
              info
            </mat-icon>
          </mat-form-field>
          </div>
        
          <div>
            <div class="float-inner-component">
              <button mat-raised-button
                matTooltip="Save your changes locally for testing. Changes will be lost after leaving this site."
                color="primary" (ngSubmit)="onSubmit()">Save Settings</button>
            </div>

            <div class="float-inner-component">
              <button mat-raised-button matTooltip="Restore your locally saved values." color="primary"
                (click)="resetChart()">Reset to Saved Settings</button>
            </div>

            <!-- <div class="float-inner-component">
              <button mat-raised-button
                matTooltip="Update your changes to our database. Changes will be saved after leaving this site."
                color="primary" (click)="updateChart()">Update Settings</button>
            </div>

            <div class="float-inner-component">
              <button mat-raised-button matTooltip="Retrieve your saved values from our database." color="primary"
                (click)="restoreChart()">Restore User Defaults</button>
            </div> -->

            <div class="float-inner-component">
              <button mat-raised-button matTooltip="Reset all values to 0." color="primary"
                (click)="clearChart()">Clear</button>
            </div>
          </div>

        </div>
     </form>
      </div>
    </div>
  </mat-tab>
  <mat-tab label="Products and Services">
    <form [formGroup]="calcRevenueFormGroup" novalidate (ngSubmit)="update()">
      <div class="col">
        <div formArrayName="offerListArray">
          <button (click)="addOfferList()" class="block" mat-raised-button color="primary">Add Product or Service</button>
          <div *ngFor="let offer of offerList().controls; let i=index" [formGroupName]="i">
            <mat-form-field class="full-width">
              <input matInput placeholder="Offer Type" formControlName="offerType" required>
            </mat-form-field>
            <mat-form-field class="full-width">
              <input matInput placeholder="Offer Name" formControlName="offerName" required>
            </mat-form-field>
            <mat-form-field class="full-width">
              <input matInput placeholder="Offer Description" formControlName="offerDescription" required>
            </mat-form-field>
            <mat-form-field class="full-width">
              <input matInput placeholder="Offer Price" formControlName="offerPrice" required>
            </mat-form-field>
            <button (click)="removeOfferList(i)" class="btn btn-danger">Remove</button>
        </div>
        </div>
      </div>
  </form>
  </mat-tab>
</mat-tab-group>